import type { InboxAlertsTranslation } from './en';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const inboxAlertsUr: InboxAlertsTranslation = {
  status: {
    label: 'آپ کی حالت',
    online: 'آن لائن',
    away: 'غیر موجود',
    offline: 'آف لائن',
    hint: 'صارفین کو صرف اسی وقت بتایا جاتا ہے کہ کوئی فرد آن لائن ہے جب جواب دے سکنے والا کوئی ساتھی آن لائن ہو۔',
    idle: 'آپ کی ٹیم آپ کو غیر موجود دیکھتی ہے: چند منٹ سے Studio استعمال نہیں ہوا۔',
    changed: 'آپ کی حالت اب {{status}} ہے۔',
    teammate: '{{name}}، {{status}}',
  },
  settings: {
    button: 'الرٹس',
    title: 'آوازیں اور ڈیسک ٹاپ الرٹس',
    description: 'یہ ترتیبات صرف آپ کی ہیں۔ ہر ساتھی کی اپنی ترتیبات رہتی ہیں۔',
    mute: 'تمام آوازیں خاموش کریں',
    muteHint: 'ڈیسک ٹاپ الرٹس اور براؤزر ٹیب کی گنتی پھر بھی کام کرتی رہے گی۔',
    volume: 'آواز کی سطح',
    volumeValue: '{{value}} فیصد',
    silent: 'آوازیں خاموش ہونے پر یا آواز کی سطح 0 ہونے پر کوئی آواز نہیں بجے گی۔',
    events: {
      title: 'ہر واقعے کے لیے آواز',
      newChat: 'کوئی چیٹ کسی فرد کا انتظار کر رہی ہے، یا جواب کا وقت گزر گیا ہے',
      customerMessage: 'کوئی صارف آپ کی چیٹ میں، یا ایسی چیٹ میں لکھتا ہے جسے کسی نے نہیں لیا',
      assigned: 'کوئی چیٹ آپ کو پیش، سونپی یا منتقل کی گئی',
    },
    sounds: {
      chime: 'گھنٹی کی دھن',
      pop: 'پاپ',
      bell: 'گھنٹہ',
      drop: 'بوند',
      ping: 'پنگ',
      none: 'کوئی آواز نہیں',
    },
    play: '{{sound}} چلائیں',
    blocked: 'آپ کے براؤزر نے آواز بند رکھی۔ صفحے پر کہیں ایک بار کلک کریں، پھر دوبارہ کوشش کریں۔',
    saveFailed: 'آپ کی آخری تبدیلی محفوظ نہیں ہو سکی۔ ترتیبات وہی دکھاتی ہیں جو محفوظ ہے۔',
    desktop: {
      title: 'ڈیسک ٹاپ الرٹس',
      enabled: 'Studio پس منظر میں ہو تو ڈیسک ٹاپ الرٹ دکھائیں',
      enabledHint: 'آپ کہیں اور ہوں تو ہر نئی چیٹ، پیغام یا تفویض پر ایک الرٹ ملتا ہے۔',
      preview: 'صارف کے پیغام کا آغاز دکھائیں',
      previewHint: 'اگر دوسرے لوگ آپ کی اسکرین دیکھ سکتے ہیں تو اسے بند کریں۔',
      unsupported: 'یہ براؤزر ڈیسک ٹاپ الرٹس نہیں دکھا سکتا۔',
      prompt: 'آپ کا براؤزر اجازت مانگے گا۔ “اجازت دیں” چنیں۔',
      allow: 'ڈیسک ٹاپ الرٹس کی اجازت دیں',
      granted: 'اس براؤزر میں ڈیسک ٹاپ الرٹس کی اجازت ہے۔',
      denied:
        'اس براؤزر میں ڈیسک ٹاپ الرٹس بند ہیں۔ انہیں چالو کرنے کے لیے براؤزر کی ترتیبات میں اس سائٹ کے لیے اطلاعات کی اجازت دیں، پھر یہ صفحہ دوبارہ لوڈ کریں۔',
      test: 'ٹیسٹ الرٹ بھیجیں',
      testTitle: 'Hamnivo ٹیسٹ الرٹ',
      testBody: 'ڈیسک ٹاپ الرٹ ایسا دکھتا ہے۔ Studio میں واپس آنے کے لیے اس پر کلک کریں۔',
    },
  },
  banner: {
    title: 'Studio پس منظر میں ہو تب بھی نئی چیٹس کی اطلاع پائیں',
    description:
      'دوسرے ٹیب یا ونڈو میں کام کرتے وقت نئی چیٹس اور پیغامات کی اطلاع پانے کے لیے ڈیسک ٹاپ الرٹس کی اجازت دیں۔',
    allow: 'ڈیسک ٹاپ الرٹس کی اجازت دیں',
    later: 'ابھی نہیں',
  },
  alert: {
    chat_waiting: '{{name}} کسی فرد کا انتظار کر رہے ہیں',
    sla_overdue: '{{name}} کے جواب کا وقت گزر گیا ہے',
    sla_overdue_lead: '{{name}} کو کسی نے وقت پر جواب نہیں دیا',
    chat_offered: '{{name}} کی چیٹ آپ کو پیش کی گئی ہے: قبول کریں یا انکار کریں',
    customer_message: '{{name}} کا نیا پیغام',
    assigned: 'آپ کو ایک چیٹ سونپی گئی',
    assignedBody: '{{name}}: {{preview}}',
    open: 'پڑھنے کے لیے چیٹ کھولیں۔',
  },
  unread: {
    row: 'غیر پڑھے پیغامات: {{count}}',
  },
  typing: {
    customer: '{{name}} لکھ رہے ہیں…',
  },
  visitor: {
    title: 'ویب سائٹ پر وزٹ',
    notNoted: 'یہ برانڈ درج نہیں کرتا کہ وزیٹر کون سے صفحات دیکھتے ہیں۔',
    none: 'اس صارف کے لیے کوئی صفحہ درج نہیں۔ ممکن ہے وہ “Do Not Track” استعمال کرتے ہوں، یا چیٹ ایسی جگہ کھلی ہو جہاں ویب سائٹ کی چیٹ اسکرپٹ نہیں چلتی۔',
    online: 'ابھی ویب سائٹ پر ہیں',
    left: 'ویب سائٹ چھوڑی {{when}}',
    currentPage: 'موجودہ صفحہ',
    entryPage: 'یہاں سے آئے',
    visits: 'وزٹ',
    visitor: 'وزیٹر',
    returning: 'دوبارہ آیا',
    new: 'نیا',
    timeOnSite: 'سائٹ پر وقت',
    underMinute: 'ایک منٹ سے کم',
    country: 'ملک',
    device: 'ڈیوائس',
    language: 'زبان',
    cameFrom: 'کہاں سے آئے',
    pages: 'اس وزٹ کے صفحات',
    untitled: 'بغیر عنوان کا صفحہ',
    openPage: '{{page}} کو نئے ٹیب میں کھولیں',
    types: { desktop: 'کمپیوٹر', mobile: 'فون', tablet: 'ٹیبلٹ', other: 'ڈیوائس' },
    privacy:
      'صفحات کوئری اسٹرنگ کے بغیر درج ہوتے ہیں اور 30 دن رکھے جاتے ہیں۔ کوئی IP ایڈریس محفوظ نہیں کیا جاتا۔',
  },
  live: {
    link: 'لائیو وزیٹر',
    title: 'لائیو وزیٹر',
    description: 'ابھی آپ کی ویب سائٹس پر موجود لوگ۔ فہرست ہر چند سیکنڈ میں اپ ڈیٹ ہوتی ہے۔',
    back: 'ان باکس پر واپس جائیں',
    brand: 'برانڈ',
    allBrands: 'تمام برانڈ',
    loading: 'وزیٹر لوڈ ہو رہے ہیں',
    summary: 'ابھی ویب سائٹ پر: {{number}}',
    updated: 'اپ ڈیٹ کیا گیا {{time}}',
    table: 'ابھی ویب سائٹ پر موجود وزیٹر',
    columns: {
      visitor: 'وزیٹر',
      page: 'صفحہ',
      time: 'سائٹ پر وقت',
      country: 'ملک',
      device: 'ڈیوائس',
      visits: 'وزٹ',
      actions: 'کارروائیاں',
    },
    returning: 'دوبارہ آیا · {{number}}',
    new: 'نیا',
    openChat: 'چیٹ کھولیں',
    openChatFor: '{{name}} کے ساتھ چیٹ کھولیں',
    invite: 'چیٹ شروع کریں',
    inviteFor: '{{name}} کے ساتھ چیٹ شروع کریں',
    empty: {
      title: 'ابھی آپ کی ویب سائٹ پر کوئی نہیں ہے',
      description:
        'وزیٹر تب تک یہاں نظر آتے ہیں جب تک ان کا کوئی صفحہ کھلا ہو۔ اس کے لیے آپ کی ویب سائٹ پر چیٹ اسکرپٹ اور برانڈ کے لیے صفحات کی ٹریکنگ آن ہونا ضروری ہے۔',
    },
    forbidden: {
      title: 'لائیو وزیٹر آپ کے لیے دستیاب نہیں ہیں',
      description: 'آپ کے کردار میں گفتگو پڑھنا شامل نہیں ہے۔',
    },
    dialog: {
      title: '{{name}} کے ساتھ چیٹ شروع کریں',
      description:
        'آپ کا پیغام اس صفحے پر چیٹ بٹن کے پاس نظر آتا ہے جسے وہ دیکھ رہے ہیں۔ اگر وہ اسے کھولیں تو چیٹ آپ کے الفاظ سے شروع ہوتی ہے۔',
      message: 'آپ کا پیغام',
      hint: 'زیادہ سے زیادہ 300 حروف۔',
      default: 'ہیلو! کیا میں کچھ ڈھونڈنے میں آپ کی مدد کر سکتا ہوں؟',
      send: 'دعوت بھیجیں',
      sent: 'دعوت بھیج دی گئی۔ یہ چند سیکنڈ میں نظر آئے گی اور 3 منٹ تک انتظار کرے گی۔',
      gone: 'یہ وزیٹر ویب سائٹ چھوڑ چکا ہے۔',
    },
    settings: {
      title: 'وزیٹر ٹریکنگ',
      description: 'چنیں کہ کوئی برانڈ درج کرے یا نہیں کہ وزیٹر کون سے صفحات دیکھتے ہیں۔',
      brand: 'برانڈ',
      tracking: 'درج کریں کہ وزیٹر کون سے صفحات دیکھتے ہیں',
      trackingHint:
        'بطور ڈیفالٹ آن۔ جن وزیٹرز کا براؤزر “Do Not Track” یا “Global Privacy Control” بھیجتا ہے وہ ہمیشہ باہر رہتے ہیں، اور چیٹ وزیٹرز کو بتاتی ہے کہ صفحات درج ہوتے ہیں۔',
      queries: 'صفحے کے پتے میں سوالیہ نشان کے بعد کا حصہ رکھیں',
      queriesHint:
        'بطور ڈیفالٹ بند: کچھ بھی محفوظ کرنے سے پہلے اسے ہٹا دیا جاتا ہے، کیونکہ اس میں ای میل ایڈریس یا آرڈر نمبر ہو سکتے ہیں۔ آن ہونے پر بھی پاس ورڈ یا ٹوکن جیسی قدریں ہٹا دی جاتی ہیں۔',
      retention:
        'وزیٹر کو آخری بار دیکھے جانے کے 30 دن بعد صفحات اور وزٹ حذف ہو جاتے ہیں۔ کوئی IP ایڈریس محفوظ نہیں کیا جاتا۔',
      save: 'محفوظ کریں',
      saved: 'محفوظ ہو گیا۔ یہ ہر وزیٹر کے اگلے صفحے سے لاگو ہوتا ہے۔',
    },
  },
  library: {
    link: 'محفوظ جوابات اور ٹیگ',
    title: 'محفوظ جوابات اور ٹیگ',
    description:
      'آپ کی ٹیم کے مشترکہ تیار جوابات اور لیبل۔ ہر تبدیلی ان سب پر لاگو ہوتی ہے جو اس برانڈ کے لیے صارفین کو جواب دیتے ہیں۔',
    back: 'ان باکس پر واپس جائیں',
    brand: 'برانڈ',
    loading: 'محفوظ جوابات اور ٹیگ لوڈ ہو رہے ہیں',
    noBrands: 'ابھی کوئی برانڈ نہیں ہے۔ محفوظ جوابات اور ٹیگ برانڈ کی چیٹ سے جڑے ہوتے ہیں۔',
    notSetUp: {
      title: '{{name}} کے لیے چیٹ ابھی سیٹ اپ نہیں ہے',
      description:
        'پہلے برانڈ کو چیٹ سے جوڑیں۔ اس کے بعد اس کے محفوظ جوابات اور ٹیگ یہاں سیٹ کیے جا سکتے ہیں۔',
      action: 'برانڈ اور انسٹال کھولیں',
    },
    forbidden: {
      title: 'محفوظ جوابات اور ٹیگ آپ کے لیے دستیاب نہیں',
      description: 'آپ کے کردار میں ان باکس کا انتظام شامل نہیں۔ کسی ایڈمن سے مدد مانگیں۔',
    },
    hint: {
      add: 'ٹیگ شامل کریں',
      ask: 'جو ان باکس کا انتظام کرتا ہے اس سے انہیں شامل کرنے کو کہیں۔',
    },
    replies: {
      title: 'محفوظ جوابات',
      description:
        'آپ کی ٹیم انہیں جواب کے خانے کے پاس «محفوظ جوابات» بٹن سے چنتی ہے۔ صارف کے نام جیسی تفصیلات چیٹ سے بھر جاتی ہیں۔',
      add: 'محفوظ جواب شامل کریں',
      search: 'محفوظ جوابات تلاش کریں',
      noMatch: 'آپ کی تلاش سے کوئی محفوظ جواب میل نہیں کھاتا۔',
      table: 'اس برانڈ کے محفوظ جوابات',
      columns: { code: 'شارٹ کوڈ', text: 'متن', actions: 'کارروائیاں' },
      edit: 'ترمیم کریں',
      editFor: 'محفوظ جواب {{code}} میں ترمیم کریں',
      delete: 'حذف کریں',
      deleteFor: 'محفوظ جواب {{code}} حذف کریں',
      empty: {
        title: 'ابھی کوئی محفوظ جواب نہیں',
        description:
          'وہ جوابات شامل کریں جو آپ کی ٹیم بار بار لکھتی ہے، جیسے کھلنے کا وقت یا واپسی کیسے کام کرتی ہے۔',
      },
      added: 'محفوظ جواب {{code}} شامل کیا گیا۔',
      saved: 'محفوظ جواب {{code}} محفوظ ہو گیا۔',
      deleted: 'محفوظ جواب {{code}} حذف کر دیا گیا۔',
      dialog: {
        addTitle: 'محفوظ جواب شامل کریں',
        editTitle: 'محفوظ جواب {{code}} میں ترمیم کریں',
        description: 'اس برانڈ کے لیے صارفین کو جواب دینے والا ہر شخص اسے فوراً استعمال کر سکتا ہے۔',
        code: 'شارٹ کوڈ',
        codeHint:
          'ایک مختصر نام جسے آپ کی ٹیم تلاش کر سکے، جیسے refund-policy۔ صرف حروف، اعداد، - اور _، خالی جگہ نہیں۔',
        codeRequired: 'شارٹ کوڈ لکھیں۔',
        codeInvalid:
          'صرف حروف، اعداد، - اور _ استعمال کریں (خالی جگہ نہیں)، زیادہ سے زیادہ 40 حروف۔',
        codeTaken: 'کوئی اور محفوظ جواب یہی شارٹ کوڈ استعمال کرتا ہے۔',
        text: 'متن',
        textHint: 'زیادہ سے زیادہ {{number}} حروف۔',
        textRequired: 'جواب کا متن لکھیں۔',
        details: 'چیٹ سے کوئی تفصیل شامل کریں',
        detailsHint:
          'جواب استعمال ہوتے وقت یہ بھر جاتی ہے۔ اگر تفصیل معلوم نہ ہو تو شخص سے اسے خود بھرنے کو کہا جاتا ہے۔',
        detail: {
          firstName: 'صارف کا پہلا نام',
          name: 'صارف کا پورا نام',
          agent: 'آپ کا نام',
          brand: 'برانڈ کا نام',
        },
        save: 'محفوظ کریں',
        add: 'جواب شامل کریں',
      },
      confirm: {
        title: 'محفوظ جواب {{code}} حذف کریں؟',
        body: 'یہ آپ کی ٹیم میں سب کے لیے غائب ہو جائے گا۔ پہلے بھیجے جا چکے پیغامات نہیں بدلتے۔',
        action: 'محفوظ جواب حذف کریں',
      },
    },
    tags: {
      title: 'ٹیگ',
      description:
        'وہ لیبل جو آپ کی ٹیم چیٹس کو ترتیب دینے اور ڈھونڈنے کے لیے لگاتی ہے۔ اسٹاف انہیں چیٹ کے تفصیلی پینل میں شامل کرتا ہے۔',
      add: 'ٹیگ شامل کریں',
      table: 'اس برانڈ کے ٹیگ',
      columns: { name: 'نام', description: 'تفصیل', actions: 'کارروائیاں' },
      edit: 'ترمیم کریں',
      editFor: 'ٹیگ {{name}} میں ترمیم کریں',
      delete: 'حذف کریں',
      deleteFor: 'ٹیگ {{name}} حذف کریں',
      empty: {
        title: 'ابھی کوئی ٹیگ نہیں',
        description: 'vip یا refund جیسے ٹیگ شامل کریں تاکہ آپ کی ٹیم چیٹس کو ترتیب دے سکے۔',
      },
      added: 'ٹیگ {{name}} شامل کیا گیا۔',
      saved: 'ٹیگ {{name}} محفوظ ہو گیا۔',
      deleted: 'ٹیگ {{name}} حذف کر دیا گیا۔',
      dialog: {
        addTitle: 'ٹیگ شامل کریں',
        editTitle: 'ٹیگ {{name}} میں ترمیم کریں',
        description: 'آپ کی ٹیم اسے فوراً چیٹس پر لگا سکتی ہے۔',
        name: 'نام',
        nameHint:
          'کم از کم 2 حروف یا اعداد؛ پہلے کے بعد - اور _ چل سکتے ہیں، جیسے vip یا order-problem۔ اسے چھوٹے حروف میں رکھا جاتا ہے۔',
        nameRequired: 'ٹیگ کا نام لکھیں۔',
        nameInvalid:
          '2 سے 50 حروف یا اعداد استعمال کریں؛ پہلے کے بعد - اور _ چل سکتے ہیں، خالی جگہ نہیں۔ اعراب والے حروف چیٹ سروس قبول نہیں کرتی: نام انگریزی حروف میں لکھیں۔',
        nameTaken: 'اس نام کا ٹیگ پہلے سے موجود ہے۔',
        renameNote: 'نام بدلنے سے یہ ٹیگ ان تمام چیٹس میں بدل جاتا ہے جن پر یہ لگا ہے۔',
        descriptionLabel: 'تفصیل',
        descriptionHint: 'اختیاری۔ زیادہ سے زیادہ {{number}} حروف۔',
        color: 'رنگ',
        colorChosen: 'منتخب رنگ: {{name}}',
        save: 'محفوظ کریں',
        add: 'ٹیگ شامل کریں',
      },
      colors: {
        blue: 'نیلا',
        green: 'سبز',
        teal: 'سبز نیلا',
        orange: 'نارنجی',
        red: 'سرخ',
        pink: 'گلابی',
        purple: 'جامنی',
        grey: 'سرمئی',
        custom: 'اپنی پسند ({{hex}})',
      },
      confirm: {
        title: 'ٹیگ {{name}} حذف کریں؟',
        body: 'یہ اس فہرست سے اور ان تمام چیٹس سے ہٹ جاتا ہے جن پر یہ لگا ہے۔',
        action: 'ٹیگ حذف کریں',
      },
    },
  },
};
